import type { CompanyInsightsFetch } from "@/modules/community/api/types/companyInsights"

import { useQuery } from "@tanstack/react-query"
import { NIL as NIL_UUID } from "uuid"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { COMPANY_INSIGHTS_QUERY_KEY, getCompanyInsights } from "@/modules/community/api/endpoints/companyInsights"
import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/community/constants/enums"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

export const useCompanyInsightsFetch = (companyId: string): CompanyInsightsFetch => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const { dataCareerCenter } = useCareerCenterFetch()
  const isLogged = !!dataCurrentUser?.isLogged
  const schoolId = dataCareerCenter?.id !== NIL_UUID ? dataCareerCenter?.id : ""

  const {
    data: dataCompanyInsights,
    isPending: isLoadingCompanyInsights,
    isSuccess: isSuccessCompanyInsights,
    isError: isErrorCompanyInsights,
  } = useQuery({
    enabled: isLogged && !!companyId,
    gcTime: QUERY_CACHE_TIME,
    // We silently fail since the data can be unavailable if the user cannot access to the data
    queryFn: () => getCompanyInsights({ companyId: companyId as string, schoolId }).catch(() => null),
    queryKey: [COMPANY_INSIGHTS_QUERY_KEY, companyId, schoolId],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCompanyInsights,
    isErrorCompanyInsights,
    isLoadingCompanyInsights,
    isSuccessCompanyInsights,
  }
}
